/**
 * @file DetailsView.jsx
 * @author Fernando Ruano
 * @description Details View Page
 */

// Dependencies
import React from 'react';
import { useLocation } from 'react-router-dom';

// Helpers

function DetailsView() {
  const { state } = useLocation();

  return (
    <div className="p-5 items-center m-auto text-baxterGray">
      <h2 className="mb-0 text-lg font-bold text-baxterGray text-left">
        {state.type}
      </h2>
      <h2 className="mt-1 text-sm font-bold text-baxterGray">
        {state.formatedDate}
      </h2>
      <div className="rounded-md border border-grayBorders p-2 mb-4 max-h-full mt-5">
        <pre className="whitespace-pre-wrap mb-0 text-sm text-baxterGray font-bold font-roboto">
          {state.valor_texto}
        </pre>
      </div>
    </div>
  );
}

export default DetailsView;
